import axios from 'axios'
import { ReactElement, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { logger } from '@percent/partner-dashboard/capabilities/logger'
import { useAuthDispatch } from '@percent/partner-dashboard/common/hooks/useAuthDispatch/useAuthDispatch'
import { config } from '@percent/partner-dashboard/config'
import { SET_LOGOUT, SET_VERIFY } from '@percent/partner-dashboard/context/auth'

export const percentClient = axios.create({
  baseURL: config.urls.api,
  withCredentials: true
})

export const WithAxios = ({ children }: { children: ReactElement }) => {
  const dispatch = useAuthDispatch()
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const pathnameRef = useRef('')
  const expiredSessionPathname = '/expired-session'

  if (!pathname.toLowerCase().startsWith(expiredSessionPathname)) pathnameRef.current = pathname + search

  useEffect(() => {
    const errorCodesToLog = [400, 403, 404]

    percentClient.interceptors.response.use(
      responseConfig => responseConfig,
      error => {
        if (error?.response?.status === 401) {
          localStorage.removeItem('authState')

          if (error.response.data.error.code === 'auth/unverified') {
            return dispatch({
              type: SET_VERIFY
            })
          }
          const searchParams = new URLSearchParams()
          searchParams.set('redirectTo', pathnameRef.current)

          dispatch({
            type: SET_LOGOUT
          })

          return navigate(`${expiredSessionPathname}?${searchParams.toString()}`)
        }

        if (error?.response?.status && errorCodesToLog.includes(error?.response?.status)) {
          logger(error)
        }

        throw error
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return children
}
